import React from 'react'
import storeItems from "../data/StoreData.json";
import FormatCurrency from './FormatCurrency';
import {useCartContext} from '../context/CartContext';
import {Link} from 'react-router-dom';

const WishListItem = ({id}) => {
    const {removeFromWishList} = useCartContext(); 
 
    const item = storeItems.find((i) => i.id === id);
    if (item == null) return null;
    

  return (
          
<tr key={item.id}>
    <td><Link to={`/Product_details/${item.id}` }><img src={item.imgUrl} alt='sora' /></Link></td>
    <td> <h2>  {item.title}  </h2> </td>
    <td> <span> {FormatCurrency(item.price)}  </span> </td>  
    <td> <span> {item.categories}  </span> </td>  
          
    <td> <button onClick={()=>removeFromWishList(id)} className=" btn btn-danger "><i className="fa-solid fa-xmark"></i></button> </td>

</tr>    
        

  )
}

export default WishListItem